(() => {
  if (customElements.get('complete-the-look-carousel')) {
    return;
  }

  class CompleteTheLookCarousel extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.controls = null;
      this.splideConfig = {
        perPage: 1.5,
        perMove: 1,
        trimSpace: false,
        focus: 0,
        omitEnd: true,
        arrows: false,
        pagination: false,
        speed: 300,
        easing: 'ease-in-out',
        waitForTransition: true,
        flickMaxPages: 0.5,
      };
    }

    connectedCallback() {
      this.initializeCarousel();
    }

    initializeCarousel() {
      const splideElement = this.querySelector('.splide');
      
      if (!splideElement) {
        console.warn('Complete-the-look: No splide element found');
        return;
      }

      // Wait for products-carousel to initialize, then override with our settings
      setTimeout(() => {
        if (splideElement.splide) {
          this.configureExistingSplide(splideElement);
        } else {
          // Fallback: initialize our own splide instance
          this.initializeOwnSplide(splideElement);
        }
        this.initControls();
      }, 100);
    }

    configureExistingSplide(splideElement) {
      // Override the existing splide configuration
      splideElement.splide.options = {
        ...splideElement.splide.options,
        ...this.splideConfig
      };
      splideElement.splide.refresh();
      this.slider = splideElement.splide;
    }

    initializeOwnSplide(splideElement) {
      // Initialize our own splide instance if products-carousel didn't
      try {
        this.slider = new Splide(splideElement, this.splideConfig).mount();
      } catch (error) {
        console.error('Complete-the-look: Failed to initialize Splide', error);
      }
    }

    initControls() {
      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
    }

    onControlClick(event) {
      event.preventDefault();

      if (!this.slider) {
        return;
      }

      const action = event.target.closest('[data-prev]') ? '<' : '>';
      this.slider.go(action);
    }
  }

  customElements.define('complete-the-look-carousel', CompleteTheLookCarousel);
})();
